<template>
  <div class="card card-researches mb-3">
    <h6 class="card-header with-elements" v-if="title">
      <div class="card-header-title">
        <i
          v-if="icon"
          class="fa text-cr-red mr-2"
          :class="[`fa-${icon}`]"
        ></i>

        <span v-if="title && translateTitle">{{ $t(title) }}</span>
        <span v-else-if="title">{{ title }}</span>
      </div>
    </h6>
    <div class="card-body pb-2">
      <div class="row">
        <div
          :class="[`col-md-${12 / columns}`]"
          v-for="commercial in researches"
          :key="commercial.id"
        >
          <v-reviewer-research-card
            :research="commercial"
          />
        </div>
      </div>

      <div
        class="mb-3 d-flex justify-content-center align-items-center"
        v-if="loadMore"
      >
        <v-button
          text="phrase.load_more"
          @click="$emit('load-more')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import ReviewerResearchCard from '@/reviewer/components/ReviewerResearchCard.vue';

export default {
  name: 'CommercialResearchesBlock',
  components: {
    'v-button': Button,
    'v-reviewer-research-card': ReviewerResearchCard,
  },
  props: {
    columns: {
      type: Number,
      default() {
        return 4;
      },
    },
    researches: {
      type: Array,
      required: true,
    },
    icon: {
      type: String,
    },
    loadMore: {
      type: Boolean,
      default() {
        return false;
      },
    },
    title: {
      type: String,
    },
    translateTitle: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
};
</script>

<style scoped>
.card-researches {
  background: rgba(255, 255, 255, 0.6);
}
</style>
